<div class="content" [class.pb-0]="!showDashboard">
  <div
    class="storage-notice"
    *ngIf="storage_space_status && !noticeDismissed"
    [class.critical]="storage_space_status === 'critical'"
  >
    <svg-icon
      src="assets/svg/warning.svg"
      [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
    ></svg-icon>
    <span class="storage-notice-text">
      {{
        (storage_space_status === 'critical'
          ? 'DASHBOARD.STORAGE_SPACE_STATUS_CRITICAL'
          : 'DASHBOARD.STORAGE_SPACE_STATUS_WARN'
        ) | translate
      }}
    </span>
    <button
      type="button"
      class="storage-notice-close"
      [attr.aria-label]="'DASHBOARD.NOTICE_DISMISS' | translate"
      (click)="noticeDismissed = true"
    >
      &times;
    </button>
  </div>
  <div class="box row flex-column-reverse mx-0 flex-lg-row">
    <app-saved-dashboard *ngIf="showDashboard"
        class="p-0 flex-grow-1 d-md-flex col-lg-8 d-lg-block">
    </app-saved-dashboard>
    <div class="content-box col-lg-4"
        [ngClass]="{'no-dashboard': !showDashboard}">
      <div class="context d-flex flex-column">
        <app-lang-selector class="align-self-end mb-base-u12 lang"
            [ngClass]="{'lang': !(content === 'login' && deviceType === 'mobile')}"
            [style]="'dropdown'"
            [enableHover]="false"
        ></app-lang-selector>
        <img class="mb-base-u8 align-self-center"
            *ngIf="theme?.logo_rec"
            alt=""
            [src]="(theme.logo_rec | secure | async)"
            [style.max-height.px]="deviceType === 'desktop' ? 50: 40">

        <ng-container [ngSwitch]="content">
          <app-login *ngSwitchCase="'login'"
              (forgetPassword)="changeContent('forget-password')">
          </app-login>

          <app-forget-password *ngSwitchCase="'forget-password'"
              (login)="changeContent('login')">
          </app-forget-password>

          <app-set-password *ngSwitchCase="'reset-password'"
              class="content-overflow">
          </app-set-password>

          <app-reset-password *ngSwitchDefault
              class="content-overflow"
          ></app-reset-password>
        </ng-container>
      </div>
    </div>
  </div>
</div>
